var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "14px",
    height: "19px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -147 -27 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 19  L 0 0.40322463929525  L 6.142603984292855 0.40322463929525  C 6.142603984292855 0.40322463929525  6.142603984292855 4.001837246362424  6.142603984292855 4.001837246362424  C 7.342060776853039 0.9213345725239122  9.628073741156204 0  12.457360926833609 0  C 12.914563033300622 0  13.200734751341113 0.02928421930357519  14 0.11488502539626472  C 14 0.11488502539626472  14 6.044993540409583  14 6.044993540409583  C 13.228681063080169 5.815222952542758  12.200254125912403 5.785939001776331  11.456881500731628 5.815223489617053  C 8.571701425059059 5.844507977457776  6.485788397035478 7.5711653404135175  6.485788397035478 11.313948022967331  C 6.485788397035478 11.313948022967331  6.485788397035478 19  6.485788397035478 19  L 0 19  Z ",
    fillRule: "nonzero",
    fill: "#e87d24",
    stroke: "none",
    transform: "matrix(1 0 0 1 147 27 )"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/r.69356ab30d4fbfbe33f413a74742f812.svg";
export { ForwardRef as ReactComponent };